import { useEffect } from "react";

/**
 * Injecte des données structurées BreadcrumbList (schema.org) pour un meilleur
 * affichage dans Google. items = [{ name, path? }] ; le dernier élément (page
 * courante) peut ne pas avoir de path.
 */
export default function BreadcrumbJsonLd({ items = [] }) {
  useEffect(() => {
    const clean = (items || []).filter((it) => it && it.name);
    if (clean.length < 2) return;
    const origin = typeof window !== "undefined" ? window.location.origin : "";
    const ld = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: clean.map((it, i) => ({
        "@type": "ListItem",
        position: i + 1,
        name: it.name,
        ...(it.path ? { item: `${origin}${it.path}` } : {}),
      })),
    };
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute("data-breadcrumb-ld", "1");
    el.text = JSON.stringify(ld);
    document.head.appendChild(el);
    return () => {
      document.querySelectorAll('script[data-breadcrumb-ld]').forEach((n) => n.remove());
    };
  }, [JSON.stringify(items)]);
  return null;
}
